import { createFileRoute } from '@tanstack/react-router';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';

export const Route = createFileRoute('/_app/admin/tracks/$trackId')({
  params: { parse: ({ trackId }) => ({ trackId: trackId as Id<'tracks'> }) },
});
